import { useQuery } from "@tanstack/react-query";
import { callApi, HttpMethod } from "src/services/apiService";
import { TC } from "../utils/trustCallApi";
import type { PaginatedResponse, TrustCallPhone } from "../types";

interface ActivePhonesParams {
  page: number;
  pageSize: number;
  sortBy?: string;
  direction?: string;
  searchString?: string;
  filterBy?: string;
  ftcFilterDays?: string;
}

export function useActivePhones(params: ActivePhonesParams) {
  const queryString = new URLSearchParams({
    page: String(params.page),
    pageSize: String(params.pageSize),
    ...(params.sortBy && { sortBy: params.sortBy }),
    ...(params.direction && { direction: params.direction }),
    ...(params.searchString && { searchString: params.searchString }),
    ...(params.filterBy && { filterBy: params.filterBy }),
    ...(params.ftcFilterDays && { ftcFilterDays: params.ftcFilterDays }),
  }).toString();

  return useQuery<PaginatedResponse<TrustCallPhone>>({
    queryKey: ["trustcall", "phones", "active", params],
    queryFn: () => callApi(`${TC.PHONES}?${queryString}`, HttpMethod.GET),
  });
}
